import { render, staticRenderFns } from "./CakaOrder.vue?vue&type=template&id=1cfdf97f&scoped=true&"
import script from "./CakaOrder.vue?vue&type=script&lang=js&"
export * from "./CakaOrder.vue?vue&type=script&lang=js&"
import style0 from "./CakaOrder.vue?vue&type=style&index=0&id=1cfdf97f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfdf97f",
  null
  
)

export default component.exports